export enum TeamManagementComponentEnum {
  TEAMS = "teams",
  MEMBERS = "members",
  RESOURCE_AVAILABILITY = "resource-availability",
}
